import { useEffect, useMemo, useState } from 'react';
import { journeyAPI } from '../../lib/api';
import { createTlaNextActionResolver } from '../config/nextActionResolver.tla';
import { resolveDashboardPath } from '../config/resolveDashboardPath.tla';

// Read-only next action. Reuses the EXISTING GET /api/journeys/me/recommendations via the
// app api client; never writes. Always yields a valid NextAction (safe default = dashboard).
export function useNextAction(auth) {
  const resolver = useMemo(
    () =>
      createTlaNextActionResolver({
        fetcher: async () => {
          const res = await journeyAPI.getRecommendations();
          const data = res && res.data;
          if (Array.isArray(data)) return data;
          if (data && Array.isArray(data.recommendations)) return data.recommendations;
          return [];
        },
        resolveDashboardPath,
      }),
    []
  );

  const [nextAction, setNextAction] = useState(() => ({
    path: resolveDashboardPath(auth || {}).path || '/',
    labelKey: 'experience.flowbar.dashboard',
    source: 'default',
  }));

  const isAuthenticated = !!(auth && auth.isAuthenticated);
  const isAdmin = !!(auth && auth.isAdmin);
  const isOwner = !!(auth && auth.isOwner);

  useEffect(() => {
    let cancelled = false;
    if (!isAuthenticated) {
      setNextAction({ path: '/', labelKey: 'experience.flowbar.dashboard', source: 'default' });
      return () => {
        cancelled = true;
      };
    }
    resolver.resolve({ auth: { isAuthenticated, isAdmin, isOwner } }).then((a) => {
      if (!cancelled) setNextAction(a);
    });
    return () => {
      cancelled = true;
    };
  }, [isAuthenticated, isAdmin, isOwner, resolver]);

  return nextAction;
}
